export enum DocumentRequestErrorCodes {
  NoError               = 0,    // エラーなし.
  ValidationError       = 1,    // 登録検証エラー.
  InvalidRequest        = 2,    // 要求不正.
  UncaughtException     = 254,  // 予期せぬ例外.
//  ProcessTimeout        = 255,  // 登録処理実行タイムアウト.(起動元が検出するのでフロントエンドでは使わない.)
}
